module.exports = __webpack_public_path__ + "img/item-3.0d9f5d02.png";